var _style, _defs, _defs2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42.32 41.15",
    style: {
      enableBackground: "new 0 0 42.32 41.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000018212626646911311410000010328339582236870043_);fill:none;stroke:#000000;stroke-width:1.5;}\n\t.st1{clip-path:url(#SVGID_00000175314874804550737060000016440652732543760011_);fill:none;stroke:#000000;stroke-width:1.5;}\n\t.st2{fill:none;stroke:#000000;stroke-width:1.3;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 42.1,
    y: -1.21,
    transform: "matrix(0.0536 -0.9986 0.9986 0.0536 41.2754 62.2923)",
    width: 22.81,
    height: 21.16
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049933065174966686480000006414387285065074350_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000049933065174966686480000006414387285065074350_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    d: " M63.96-0.86"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000049933065174966686480000006414387285065074350_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    d: " M43.04,19.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129195628869213207660000001381633215224511376_",
    x: 52.46,
    y: 2.9,
    transform: "matrix(0.9986 -0.0536 0.0536 0.9986 -0.676 3.3998)",
    width: 21.16,
    height: 22.81
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165215299782309186860000015157014679576316309_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129195628869213207660000001381633215224511376_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000165215299782309186860000015157014679576316309_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.5
    },
    x1: 73.5,
    y1: 24.53,
    x2: 52.58,
    y2: 4.07
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.61,
    y: 0.66,
    className: "st2",
    width: 41.06,
    height: 39.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.37c2fa64ecd5d2e308b65142f7dcabe6.svg";
export { ForwardRef as ReactComponent };